export class TimerOptions {
  showWarningColours = true;
}
